<div class="table-container">
  <ng2-smart-table
    [settings]="tableSettings"
    [source]="teams"
    (deleteConfirm)="onDeleteConfirm($event)"
    (editConfirm)="onEditConfirm($event)"
    (rowSelect)="onRowSelect($event)">
  </ng2-smart-table>
</div>
